module.exports = __webpack_public_path__ + "static/media/deleteIcon.29b26da4.svg";